var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsThanks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8831 2.14112C44.1017 1.23171 46.4449 0.636357 48.8399 0.477827C63.5423 -0.634188 74.0394 11.6494 75.2209 25.6629C75.6057 32.9138 74.357 40.1871 71.5527 46.8613C67.4508 56.201 62.3861 65.0754 56.4213 73.3768L55.7593 74.2665L54.6137 74.0767C44.5245 72.3968 34.6461 69.6476 25.0913 65.8648C18.441 63.0661 12.4575 58.7982 7.60732 53.3777C-1.45361 42.5939 -2.59802 26.4767 8.76547 16.8183C9.6414 16.0497 10.5921 15.3734 11.5909 14.8043L12.0128 14.6313C12.9419 14.0826 13.8953 13.6133 14.8798 13.2097L15.2666 13.0512C17.5092 12.2104 19.8121 11.717 22.179 11.5699L22.3865 11.4849C22.5544 11.4939 22.6901 11.5243 22.7877 11.562C23.6668 11.4925 24.5166 11.4718 25.3779 11.5692L26.9584 11.6176C27.3515 11.657 27.8216 11.7708 28.2274 11.8693C28.485 11.9315 28.7166 11.9877 28.8871 12.0147C28.9582 12.025 29.0305 12.035 29.1032 12.0452C29.4765 12.0971 29.8658 12.1511 30.2135 12.245C32.8996 7.66701 36.9816 4.10991 41.8831 2.14112ZM61.584 23.5532C63.0097 22.9238 63.7675 21.2658 63.2679 19.7464L63.0969 19.3291C61.1888 14.3736 56.3799 11.1477 51.1364 11.2903C49.4922 11.3868 48.2276 12.8102 48.3038 14.4991C48.4152 16.1735 49.8499 17.4693 51.5407 17.3864C54.1395 17.3041 56.5547 18.8983 57.5593 21.3492L57.6039 21.4578C57.8662 22.2882 58.4264 22.9636 59.163 23.3579C59.8996 23.7522 60.7802 23.7967 61.584 23.5532Z",
    fill: "url(#paint0_linear_4300_3292)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4300_3292",
    x1: 22.2699,
    y1: -7.13523,
    x2: 66.4897,
    y2: 100.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsThanks);
export default __webpack_public_path__ + "static/media/stats-thanks.9651d2a611a1ae76fb748097e87be717.svg";
export { ForwardRef as ReactComponent };